<template>
	<div class="index">
		<div class='banners'>
			<img :src="con.banner" alt="">
		</div>
		<div class='dfj'>
			<div class='card'>
				<div style="display: flex;justify-content: space-between;align-items: flex-end;flex-direction: row-reverse;"
					v-if="con.is_manager == 1">
					<!-- <div style="font-size: 0.6em; word-break: break-all;text-align: right;/*margin-bottom: 1.5em;*/">
						天娱数科（002354.SZ)
					</div> -->
					<!-- <div class='logo' v-if="con.is_manager==0">
						<img :src="con.logo" alt="">
					</div>
					<div class="logo" v-else>
						<img :src="con.exclusive_logo" alt="" />
					</div> -->
					<div class="logo" style="height: 2.5em;">
						<img :src="con.exclusive_logo" alt="" />
					</div>
				</div>
				<div style="display: flex;justify-content: space-between;align-items: center;flex-direction: row-reverse;"
					v-if="con.is_manager != 1">
					<div style="font-size: 0.6em; word-break: break-all;text-align: right;/*margin-bottom: 1.5em;*/">
						天娱数科（002354.SZ)
					</div>
					<div class='logo' v-if="con.is_manager==0">
						<img :src="con.logo" alt="">
					</div>
					<div class="logo" v-else>
						<img :src="con.exclusive_logo" alt="" />
					</div>
				</div>
				<!--  style="margin-top: .3rem;" -->
				<div class='IDname' v-if="con.is_manager == 1">{{con.name}}</div>
				<div class='mingpian' :style="con.is_manager==1?'margin-top: 0.8em;':''">
					<div :class="level[1]?'pin':'pin1'">
						<div class='IDname' v-if="con.is_manager == 0">{{con.name}}</div>
						<div class='zhiwei' v-for="(i,index) in level">{{i}}</div>
						<!-- <div v-if="level">
							<div class='zhiwu'  v-if="level[1]" >山西省数字产业协会{{level[1]}}</div>
							<div class='zhiwu1'  v-else> 11 </div>
						</div> -->

					</div>
					<div class='right' :style="con.is_manager!=1?'margin-top:.4em;':''">
						<div class='smallMsg' style="margin-bottom: 0.4em;">
							<img style="margin-right: 4px;" src="../../assets/images/phone.png" alt="">
							<a class="text" :href="'tel:'+con.phone">{{con.phone}}</a>

						</div>
						<div class='smallMsg copy-data' :data-clipboard-text="con.e_mail" style="margin-bottom: 0.4em;">
							<img src="../../assets/images/msg.png" alt="">
							<div class="text">{{con.e_mail || '暂无'}}</div>
						</div>
						<!-- <div class='smallMsg' style="margin-bottom: 0.4em;" v-if="con.is_manager!=1">
							<img src="../../assets/images/www.png" alt="">
							<a class="text" :href="'http://'+con.inc_url">{{con.inc_url}}</a>
						</div> -->
						<div class='smallMsg' @click='gogogo' v-if="con.is_manager!=1">
							<img src="../../assets/images/map.png" alt="">
							<div class="text">{{con.address || '暂无'}}</div>
						</div>
						<div class='smallMsg' @click='gogogo1(index)' v-else v-for="(item,index) in bossAdress"
							:style="index*1 == 0 ? 'margin-bottom: .4em;' : ''">
							<img src="../../assets/images/map.png" alt="">
							<div class="text">{{item}}</div>
						</div>

					</div>

				</div>
			</div>
			<div v-if="con.is_manager==1" class="flexView">
				<div class="flexView2">
					<div class='mycard'>
						<img :src="con.gongzhonghao" alt="">
					</div>
					<div class='companyName'>
						{{con.site_name}}
					</div>
				</div>
				<!-- <div class="flexView2">
					<div class='mycard'>
						<img :src="con.exclusive_qr" alt="">
					</div>
					<div class='companyName'>
						{{con.qrcode_name}}
					</div>
				</div> -->

			</div>
			<div class='mycard' v-if="con.is_manager==0">
				<img :src="con.gongzhonghao" alt="">
			</div>
			<div class='companyName' v-if="con.is_manager==0">
				{{con.site_name}}
			</div>
			<div class='phones' @click='followTap'>
				<img src="../../assets/images/jia.png" alt="" style="width: 1.4em;height: 1.4em;margin-right: 5px;">
				<div>添加到通讯录</div>

			</div>
		</div>

		<Popup v-model="followCode" closeable :style="{ height: '8rem',width:'99%',background:'#fff' }">
			<div style="margin-top: 18px;margin-left: 20px;padding-bottom: 18px; font-size: 14px;letter-spacing: 3px;">
				添加到通讯录
			</div>
			<div style="border-bottom:1px solid rgb(249, 245, 245) ;"></div>
			<img :src="con.wechat_img" style=" width: 250px;
					display: block;
					margin:0 auto;
					position: absolute;
					top: 18%;
					bottom: 0;
					left: 0;
					right: 0;" />
			<div style="margin-top: 13px;margin-left: 20px;font-size: 14px;position: absolute;
					top: 81%;
					bottom: 0;
					left: 0;
					right: 0;">
				<div style="border-bottom:1px solid rgb(249, 245, 245) ;"></div>
				<div style="display: flex;align-items: flex-end;justify-content: space-between;">
					<div style="margin-top: 10px;width: 60%;">
						<div style="text-align: right;">长按二维码，选择识别图中二维码</div>
						<!-- <div style="text-align: right;margin-top: 5px;">技术支持：斯飞科技</div> -->
					</div>
					<div style="margin-top: 10px;width: 60px;height: 35px;border: 1px solid #dfdfdf;background-color: #f4f4f4;line-height: 35px;margin-right: 20px;text-align: center;border-radius: 2px;"
						@click='btn'>关闭</div>
				</div>

			</div>
		</Popup>
	</div>
</template>

<script>
	import {
		getLevelZhiwei
	} from '../../api/store'
	import ClipboardJS from "clipboard";
	import {
		// openShareAppMessage,
		// openShareTimeline,
		ready,
		wx_getLocation
	} from "@libs/wechat";
	import {
		isWeixin
	} from "@utils/index";
	import {
		Popup
	} from "vant";
	import {
		getShare,
		getMailDetail,
		getWechatConfig
	} from "@api/public";
	import axios from "axios";
	export default {
		name: "Index",
		components: {
			Popup,
		},
		props: {},
		data: function() {
			return {
				followCode: false,
				name: '',
				con: {},
				id: '',
				isShow: false,
				level: '',
				link: '',
				img: '@assets/images/logs.png',
				bossAdress: []
			};
		},

		watch: {
			$route: {
				immediate: true, // 立即执行
				deep: true, // 深度监听复杂类型内变化
				handler(newVal, oldVal) {
					if (newVal) {
						this.name = newVal.query.name
						this.id = newVal.query.con
						if (this.id) {
							this.$nextTick(() => {
								this.getMailDetail(this.id)
							})
						}
					}
				}
			}

			// "$route.query.name": function(n) {
			// 	if (n) {
			// 		this.name = this.$route.query.name
			// 		this.id = this.$route.query.con

			// 		this.$nextTick(() => {
			// 			this.getMailDetail(this.id)
			// 		})
			// 	}
			// },

		},
		created() {
			if (isWeixin() === true) {
				this.setNOpenShare();
			}
		},
		mounted() {
		
			// if (this.$route.query.name) {
			// 	this.name = this.$route.query.name
			// 	this.id = this.$route.query.con
			// } else {
			// 	this.name = this.$route.params.name;
			// 	this.id = this.$route.params.con;
			// }
			// this.$nextTick(() => {
			// 	this.getMailDetail(this.id)
			// })
			this.$nextTick(function() {
				var copybtn = document.getElementsByClassName("copy-data");
				const clipboard = new ClipboardJS(copybtn);
				clipboard.on("success", () => {
					this.$dialog.success("复制成功");
				});
			});
		},
		methods: {
			
			goMenus() {
				this.$router.push({
					path: '/detail',
				});
			},
			getMailDetail(id) {
				// alert(id)
				getMailDetail({
					id: id
				}).then(res => {
					this.level = res.data.info.level.split(',')
					this.con = res.data.info
					this.bossAdress = this.con.manager_address.split('；')
					this.$nextTick(function() {
						this.updateTitle()
						this.setOpenShare();
						// this.getLevelZhiwei()
					})

				}).catch(err => {
					// this.$dialog.error(err)
					console.log(err)
					// alert(err.msg)
				})
			},
			followTap() {
				this.followCode = true;
			},
			btn() {
				this.followCode = false;
			},
			// async getLevelZhiwei() {
			// 	const res = await getLevelZhiwei()
			// 	res.data.forEach(item => {
			// 		if (item.id == this.con.level) {
			// 			this.level = item.level
			// 		}
			// 	})
			// },
			gogogo() {
				var that = this;
				if (isWeixin() === true) {
					ready().then(() => {
						//获得定位并更新门店数据
						wx.openLocation({
							latitude: parseFloat(that.con.lat), // 纬度，浮点数，范围为90 ~ -90dsds
							longitude: parseFloat(that.con.lon), // 经度，浮点数，范围为180 ~ -180。
							name: that.con.address, // 位置名
							address: '', // 地址详情说明
							scale: 15, // 地图缩放级别,整形值,范围从1~28。默认为最大
							success(res) {
								console.log('成功了吗', res)
							},
						});
					});
				}
			},
			gogogo1(e) {
				var that = this;
				console.log(1111111)
				let address2 = this.bossAdress[e]
				console.log(288, address2)
				// 纬度
				let latitude = '';
				// 经度
				let longitude = '';
				that.con.manager_lon.split(',').forEach((item, index) => {
					console.log(item, index)
					if (index == e) {
						longitude = item
					}
				})
				that.con.manager_lat.split(',').forEach((item, index) => {
					console.log(item, index)
					if (index == e) {
						latitude = item
					}
				})
				console.log('longitude', longitude)
				console.log('latitude', latitude)
				if (isWeixin() === true) {
					ready().then(() => {
						//获得定位并更新门店数据
						wx.openLocation({
							latitude: parseFloat(latitude), // 纬度，浮点数，范围为90 ~ -90dsds
							longitude: parseFloat(longitude), // 经度，浮点数，范围为180 ~ -180。
							name: address2, // 位置名
							address: '', // 地址详情说明
							scale: 15, // 地图缩放级别,整形值,范围从1~28。默认为最大
							success(res) {
								console.log('成功了吗', res)
							},
						});
					});
				}
			},
			setOpenShare: function() {
				let that = this;

				// var link =  window.location.origin+'/detail?name='+this.name+'&con='+this.id;

				// var link = location.href.split("?")["0"] + '?name=' + this.name + '&con=' + this.id
				const currentUrl = window.location.origin; // 关键点：动态获取当前URL
				const shareLink = currentUrl + `/detail?name=${this.name}&con=${this.id}`;
				// alert(link);
				// this.link = link;
				console.log(window.location.origin)
				console.log(currentUrl)
				console.log(shareLink)
				var configAppMessage = {
					// desc: '山西数据流量谷',
					desc: '中科售电',
					// desc: '山西数据流量生态园',
					// desc:'山西北仑巨邦创新科技有限公司',
					title: this.con.name + ' 的电子名片',
					link: shareLink,
					imgUrl: window.location.origin + '/log1.png'
				};
				var configTimeline = {
					title: this.con.name + ' 的电子名片',
					link: shareLink,
					imgUrl: window.location.origin + '/log1.png'
				};
				console.log(encodeURIComponent(shareLink))
				let myUrl = 'https://dl.shsfkjgs.com/test.php?url=' + encodeURIComponent(shareLink)
				// alert(myUrl);
				console.log(myUrl);
				axios.get(myUrl).then(res => {
				// axios.get('https://dl.shsfkjgs.com/test.php?url=' + encodeURIComponent(shareLink)).then(res => {
					console.log(res)
					// alert(111);
					wx.config({
						debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来
						appId: res.data.data.appId, // 必填，公众号的唯一标识
						timestamp: res.data.data.timestamp, // 必填，生成签名的时间戳
						nonceStr: res.data.data.nonceStr, // 必填，生成签名的随机串
						signature: res.data.data.signature, // 必填，签名
						jsApiList: ['updateAppMessageShareData',
							'updateTimelineShareData','checkJsApi'] // 必填，需要使用的JS接口列表
						
					})
					// if (isWeixin() === true) {
						// this.link += 'true';
						wx.ready(() => {
							// alert(111);
							//自定义“分享给朋友”及“分享到QQ”按钮的分享内容
							wx.updateAppMessageShareData(configAppMessage);
							//自定义“分享到朋友圈”及“分享到 QQ 空间”按钮的分享内容（1.4.0）
							wx.updateTimelineShareData(configTimeline);
							
						});
					// } else {

					// 	// this.link += 'false';
					// }
				}).catch(err => {
					console.log(err)
					// alert(396+err);
				})
			},
			setNOpenShare: function() {
				let that = this;
				const urlStr = localStorage.getItem('starUrl');
				// var link =  window.location.origin+'/detail?name='+this.name+'&con='+this.id;
			
				// var link = location.href.split("?")["0"] + '?name=' + this.name + '&con=' + this.id
				const currentUrl = window.location.origin; // 关键点：动态获取当前URL
				const shareLink = currentUrl + `/detail?name=${this.name}&con=${this.id}`;
				// alert(link);
				// this.link = link;
				console.log(window.location.origin)
				console.log(currentUrl)
				console.log(shareLink)
				var configAppMessage = {
					// desc: '山西数据流量谷',
					desc: '中科售电',
					// desc: '山西数据流量生态园',
					// desc:'山西北仑巨邦创新科技有限公司',
					title: "eeee" + ' 的电子名片',
					link: shareLink,
					imgUrl: window.location.origin + '/log1.png'
				};
				var configTimeline = {
					title: this.con.name + ' 的电子名片',
					link: shareLink,
					imgUrl: window.location.origin + '/log1.png'
				};
				console.log(encodeURIComponent(shareLink))
				// alert(1111,urlStr)
				let myUrl = 'https://dl.shsfkjgs.com/test.php?url=' + encodeURIComponent(urlStr)
				axios.get(myUrl).then(res => {
					// alert(333,res.data.data);
					wx.config({
						debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来
						appId: res.data.data.appId, // 必填，公众号的唯一标识
						timestamp: res.data.data.timestamp, // 必填，生成签名的时间戳
						nonceStr: res.data.data.nonceStr, // 必填，生成签名的随机串
						signature: res.data.data.signature, // 必填，签名
						jsApiList: ['updateAppMessageShareData',
							'updateTimelineShareData','checkJsApi'] // 必填，需要使用的JS接口列表
						
					})
					// if (isWeixin() === true) {
						// this.link += 'true';
						wx.ready(() => {
							
							// alert(114);
							//自定义“分享给朋友”及“分享到QQ”按钮的分享内容
							wx.updateAppMessageShareData(configAppMessage);
							//自定义“分享到朋友圈”及“分享到 QQ 空间”按钮的分享内容（1.4.0）
							wx.updateTimelineShareData(configTimeline);
							
							// // openShareAppMessage(configAppMessage).then(() => {});
							// openShareTimeline(configTimeline).then(() => {});
						});
					}).catch(err => {
						console.log(err)
						// alert(456+err);
					})
			},
			updateTitle() {
				
				// document.title = this.con.name + '的电子名片3' || this.$route.meta.title;
			},
			copy() {
				var that = this
				var clipboard = new Clipboard('.copy')
				clipboard.on('success', e => {
					console.log(e)
					that.$dialog.success('复制成功')
					// 释放内存
					clipboard.destroy()
				})
				clipboard.on('error', e => {
					// 不支持复制
					console.log(e)
					that.$dialog.error('该浏览器不支持复制')
					// 释放内存
					clipboard.destroy()
				})
			}
		}
	};
</script>
<style scoped>
	#launch-btn {
		display: block;
		width: 100%;

	}

	.index {
		background-color: #fff;

		/* height: 100%; */
	}

	.banners {
		width: 100%;
		position: relative;
		/* height: 230px; */
	}

	.wenzi {
		position: absolute;
		top: 40%;
		color: #fff;
	}

	.banners img {
		width: 100%;
		height: 100%;
	}

	.dfj {
		position: relative;
		top: -1.5em;
		/* margin-bottom: 2em; */
	}

	.card {
		margin: 0 auto;
		width: 88%;
		min-height: 14em;
		border-radius: 8px;
		background-color: #fff;
		box-shadow: 0 0 20px #cdcaca;
		/* padding: 1em 1em 2.5em 1.5em; */
		padding: 1em 1em 1em 1.5em;
	}

	.flexView {
		display: flex;
		align-items: center;
		justify-content: space-evenly;
	}

	.flexView2 {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.mycard {
		text-align: center;
		margin: 1.5em auto 1em;
		width: 7em;
		height: 7em;
	}

	.mycard img {
		width: 100%;
		height: 100%;
	}

	.companyName {
		text-align: center;
		margin: 0px auto 1.5em;
		color: #b5b3b3;
		font-size: 0.9em;
	}

	.phones {
		line-height: 2.5em;
		width: 60%;
		background-color: #06a759;
		border-radius: 2px;
		margin: 0 auto;
		color: #e9e1e1;
		letter-spacing: 1.5px;
		display: flex;
		align-items: center;
		justify-content: center
	}

	.logo {
		/* width: 100px; */
		height: 2em;
	}

	.logo img {
		/* width: 100%; */
		height: 100%;
	}

	.mingpian {
		display: flex;
		justify-content: start;
		margin-top: 1.8em;
		/* margin-top: 0.8em; */
		align-items: center;
	}

	.pin {
		height: 1rem;
		min-width: 46%;
		max-width: 46%;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		/* flex-wrap: wrap; */
	}

	.pin1 {
		min-width: 42%;
		max-width: 42%;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		flex-wrap: wrap;
		margin-left: 1em;

	}

	.right {
		display: flex;
		flex-direction: column;
		justify-content: start;
		flex-wrap: wrap;
		/* padding-top: .4em; */
	}

	.IDname {
		font-size: 1.6em;
		font-weight: 700;
		letter-spacing: 2px;
		/* margin-top: .2em; */
	}

	.zhiwei,
	.zhiwu {
		font-size: 0.7em;
		word-break: break-all;
		white-space: normal;
		/* flex-wrap: wrap; */
		/* transform: scale(0.8); */
		/* -webkit-text-size-adjust: none;
		display: inline-block; */
		/* transform-origin: 0 0; */
	}

	.zhiwu1 {
		font-size: 0.7em;
		word-break: break-all;
		white-space: normal;
		color: #fff;
	}

	.smallMsg {
		/* max-width: 50%;
		min-width: 50%; */
		display: flex;
		align-items: stretch;
		justify-content: start;
		/* flex-wrap: wrap; */
	}

	.smallMsg img {
		width: 1em;
		height: 1em;
		margin-right: 5px;
	}

	.smallMsg .text {
		font-size: 0.6em;
		text-decoration: underline;
		text-align: justify;
		word-break: break-all;
		/* line-height: 14px; */

	}

	.van-popup--center {
		top: 14em;
	}

	.van-popup__close-icon {
		font-size: 16px;
	}
</style>